<div [class.content-blurred]="isLoading">
  <form [formGroup]="form" id="formGroup" class="needs-validation">
    <div class="position-relative row form-group">
      <label for="name_Id" class="col-sm-2 col-form-label"
        >{{ "Form.NAME" | translate }} <span class="text-danger">*</span></label
      >
      <div class="col-sm-10">
        <input
          formControlName="name"
          name="name"
          id="name_id"
          type="text"
          class="form-control"
          placeholder="Name"
          required
        />
        <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
          <div *ngIf="f.name.errors.required">
            {{ "Form.Error.NAME" | translate }}
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex mt-2 mb-2 justify-content-end">
      <button
        style="
          border: none;
          border-radius: 50px;
          background-color: rgb(255, 238, 0);
          width: 25px;
          height: 25px;
          text-align: center;
        "
        (click)="rewriteUserguide()"
      >
        <i
          id="enhance-userguide-with-ai"
          style="font-size: 18px"
          class="fa fa-lightbulb-o"
          title="Enhance Userguide with AI"
        ></i>
      </button>
    </div>
    <div class="position-relative row form-group">
      <label for="text" class="col-sm-2 col-form-label"
        >{{ "Form.USERGUIDE" | translate
        }}<span class="text-danger">*</span></label
      >
      <div class="col-sm-10">
        <angular-editor
          id="faq-editor1"
          formControlName="text"
          [config]="config"
          required
          (click)="onEditorClick($event)"
          (mouseup)="onTextSelect($event)"
          [(ngModel)]="editorContent"
          (selectionChange)="onSelectionChange($event)"
          #editor
        ></angular-editor>

        <div *ngIf="submitted && textError" class="text-danger">
          {{ "Form.Error.USERGUIDE" | translate }}
        </div>
        <div *ngIf="imageError && !textError" class="text-danger">
          {{ "Form.Error.tooManyImages" | translate }}
        </div>
        <p
          style="
            margin-bottom: 0;
            color: red;
            font-size: small;
            text-align: right;
          "
        >
          {{ "Form.ImageSizeNote" | translate }}
        </p>
      </div>
    </div>

    <div class="position-relative row form-check">
      <div class="col-sm-10 offset-sm-2">
        <button
          class="btn px-3 border-0"
          style="margin-right: 10px"
          type="submit"
          [ngClass]="{
            'btn-primary': form.dirty,
            'btn-secondary': disbledPublishtoDev || !form.dirty
          }"
          [disabled]="disbledPublishtoDev"
          (click)="onSubmit()"
        >
          {{ "Form.PublishToDev" | translate }}
        </button>
        <button
          class="btn reset-btn text-white"
          [disabled]="!form.dirty"
          (click)="onReset()"
        >
          {{ "Form.CANCEL" | translate }}
        </button>
        <button
          class="btn border-0"
          [ngClass]="{
            'btn-primary': !form.dirty && publishToQA,
            'btn-secondary': form.dirty && !publishToQA
          }"
          [disabled]="form.dirty || !publishToQA"
          style="margin-right: 10px; margin-left: 10px"
          (click)="onClickOfPublish('qa'); form.markAsPristine()"
        >
          {{ "Form.PublishToQA" | translate }}
        </button>
        <button
          class="btn border-0"
          [ngClass]="{
            'btn-primary': !form.dirty && publishToProd && !publishToQA,
            'btn-secondary': form.dirty
          }"
          [disabled]="!(!form.dirty && publishToProd)"
          (click)="onClickOfPublish('prod')"
        >
          {{ "Form.PublishToProd" | translate }} {{ form.dirty }}
          {{ publishToProd }}
        </button>
      </div>
    </div>
    <div class="divider"></div>
    <!-- <div *ngIf="isDropdownVisible"> -->
    <ng-select
      #rolesDropdown
      [items]="roles"
      bindValue="name"
      bindLabel="displayname"
      (change)="onRoleSelectionChanges($event)"
      (click)="onDropdownClick($event)"
      formControlName="roles"
      [multiple]="true"
      [(ngModel)]="selectedRoles"
      [closeOnSelect]="false"
      id="roles-faq-editor"
      placeholder="Select roles"
      [ngStyle]="dropdownStyle"
      (remove)="onRoleRemoved($event)"
      style="
        display: none;
        width: 200px;
        height: 85%;
        white-space: nowrap;
        text-overflow: ellipsis;
        z-index: 999;
        background: #f5f5f5 !important;
        /* padding: 0.2rem; */
        /* border: 1px solid black !important; */
      "
    >
    </ng-select>
    <!-- </div> -->

    <!--  <ng-multiselect-dropdown
    [placeholder]="'Select City'"
    [data]="roles"
    [settings]="settings"
    (onFilterChange)="onFilterChange($event)"
    (onDropDownClose)="onDropDownClose($event)"
    (onSelect)="onItemSelect($event)"
    (onDeSelect)="onDeSelect($event)"
    (onSelectAll)="onSelectAll($event)"
    (onDeSelectAll)="onDeSelectAll($event)"
    style="
      display: none;
      width: 200px;
      height: 85%;
      white-space: nowrap;
      text-overflow: ellipsis;
      z-index: 999;
      background: #f5f5f5 !important;
      /* padding: 0.2rem; */
      /* border: 1px solid black !important; */
    "
  >
  </ng-multiselect-dropdown> -->
    <!--  <ng-select
    [multiple]="multiple"
    id="rolesDropdown"
    [items]="roles"
    bindLabel="displayname"
    bindValue="name"
    placeholder="Select Roles"
    style="
      display: none;
      width: 200px;
      height: 85%;
      white-space: nowrap;
      text-overflow: ellipsis;
      z-index: 999;
      background-color: #f5f5f5;
      padding: 0.2rem;
      border: 1px solid #ddd;
    "
  >
  </ng-select> -->
  </form>

  <!--   <div
    class="card-header-tab card-header"
    style="margin-bottom: -1px; border-bottom-width: 0px; padding: 3px"
    *ngIf="userguide != 'new'"
  >
    <div class="card-title font-size-md text-capitalize">
      {{ "Form.SELECT_LANGUAGE" | translate }}
    </div>
  </div>

  <div
    class="row"
    *ngIf="project && project.supportedLanguage && userguide != 'new'"
    style="margin-left: -5px"
  >
    <div
      style="
        padding: 10px;
        cursor: pointer;
        margin-bottom: 4px;
        font-size: 11px;
        height: fit-content;
      "
      class="badge col-md-1 ms-2 me-2 ps-2 pe-2"
      [ngClass]="{
        'badge-primary': currentUserGuide.languageId == project.primaryLanguage,
        'badge-secondary':
          currentUserGuide.languageId != project.primaryLanguage
      }"
      (click)="showSelectedLangaugeUserGuide(project.primaryLanguage)"
    >
      {{ getLanguageName(project.primaryLanguage) }}
    </div>
    <ng-container *ngFor="let psl of project.supportedLanguage">
      <div
        style="
          padding: 10px;
          cursor: pointer;
          margin-bottom: 4px;
          font-size: 11px;
          height: fit-content;
        "
        *ngIf="psl.id != project.primaryLanguage"
        class="badge col-md-1 ms-2 me-2 ps-2 pe-2"
        [ngClass]="{
          'badge-primary': psl.id == currentUserGuide.languageId,
          'badge-secondary': psl.id != currentUserGuide.languageId
        }"
        (click)="showSelectedLangaugeUserGuide(psl.id)"
      >
        {{ psl.name }}
      </div>
    </ng-container>
    <div
      style="
        padding: 10px;
        cursor: pointer;
        margin-bottom: 4px;
        font-size: 11px;
        height: fit-content;
      "
      class="badge col-sm-1 ms-2 badge-primary"
      (click)="open(content)"
    >
      +
    </div>
    <ng-template #content let-c="close" let-d="dismiss">
      <div class="modal-header">
        <h4 class="modal-title">
          {{ "Form.SELECT_NEW_LANGUAGE" | translate }}
        </h4>
        <button
          type="button"
          class="close mt-2"
          aria-label="Close"
          (click)="d('Cross click')"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body lang-popup">
        <overlay-scrollbars [defer]="true">
          <mat-selection-list #newLanguages class="me-2">
            <mat-list-option *ngFor="let projectSl of getNewLanguage()">
              {{ projectSl.name }}
            </mat-list-option>
          </mat-selection-list>
        </overlay-scrollbars>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="c('Close click')"
        >
          {{ "Form.CANCEL" | translate }}
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="saveNewSelectedLanguage(newLanguages)"
        >
          {{ "Form.SAVE" | translate }}
        </button>
      </div>
    </ng-template>
  </div> -->

  <div
    class="card-header-tab card-header"
    style="margin-bottom: -1px; border-bottom-width: 0px; padding: 3px"
    *ngIf="currentUserGuide.updatedAt"
  >
    <div class="card-title font-size-md text-capitalize">
      {{ "Form.Lastupdatedon" | translate }}
      {{ currentUserGuide.updatedAt | date : "yyyy-MM-dd" }}
    </div>
  </div>
</div>
<!-- <ng-container></ng-container> -->
<div *ngIf="isLoading" class="text-center overlay-loader my-3">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
